const Utility = {
  fetchChildIds: async function(productHandle) {
        try {
            const response = await fetch(`/products/${productHandle}?view=childIds`);
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            const variantIds = await response.json();
            return variantIds;
          } catch (error) {
            console.error('Error fetching product data:', error);
            return null;
          }
    },
  
  fetchProductDataAjax: async function(productHandle, productType, childIds) {
        try {
            const response = await fetch(`/products/${productHandle}.js`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            let productData = await response.json();
    
            if (productType == 'Combined Paddle' && childIds) {    
                try {
                    const response = await fetch(`https://shopifyapis.azurewebsites.net/api/fetchAllVariants?code=Ya6jqLoN9yoe3GPsxnlwLWAN-cTe_9mZGNL9daXetJ5OAzFun22jzA%3D%3D&ids=${childIds.childProducts}`);
                    if (!response.ok) {       
                        throw new Error('Network response was not ok');
                    }
    
                    // Fetch all variants from the Azure function
                    const data = await response.json();
                    
                    // Flatten the variants array to remove any pagination-related chunks
                    const allVariants = data.flat(); // This will flatten any nested arrays within `data`
    
                    // Assign the flattened variants array to productData
                    productData.variants = allVariants;
    
                    return productData;
                } catch (error) {
                    console.error('Error fetching product data:', error);
                    return null;
                }   
            } else {
                return productData;
            }  
        } catch (error) {
            console.error('Error fetching product data:', error);
            return null;
        }   
    },

    fetchProductImages: async function(productHandle, variantId) {
      try {
          const response = await fetch(`/products/${productHandle}?view=var-images&variant=${variantId}`);
          if (!response.ok) {
              throw new Error('Network response was not ok');
              return null;
          }
          
          const productImages = await response.json();
          return productImages;
      } catch (error) {
          console.error('Error fetching product data:', error);
          return null;
      }
    },
      
    fetchProductDetails: async function(productHandle, variantId) {
      try {
          const response = await fetch(`/products/${productHandle}?view=data&variant=${variantId}`);
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          const productData = await response.json();
          return productData;
        } catch (error) {
          console.error('Error fetching product data:', error);
          return null;
        }
    },
    fetchEls: function(selectors, context) {
        Object.entries(selectors).forEach(([key, {selector, type, scope}]) => {
            if (type === 'single') {
                if (scope === 'document') {
                    context[key] = document.querySelector(selector);
                } else {
                    context[key] = context.parent.querySelector(selector);
                }
            } else if (type === 'all') {
                if (scope === 'document') {
                    context[key] = document.querySelectorAll(selector);
                } else {
                    context[key] = context.parent.querySelectorAll(selector);
                }
            }
        });
    },
    shopifyHandleize: function(str) {
      return str
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')  // Replace non-alphanumeric with hyphens
        .replace(/^-+|-+$/g, '');     // Trim leading/trailing hyphens
    },
    smoothScroll: function(element, distance, duration) {
      const startTime = performance.now();
      const startPos = element.scrollLeft;
      const maxScrollLeft = element.scrollWidth - element.clientWidth;
      
      // Ensure target position is within the bounds
      const targetPos = Math.max(0, Math.min(startPos + distance, maxScrollLeft));
    
      function scrollFrame(timestamp) {
        const elapsed = timestamp - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const newPosition = startPos + (targetPos - startPos) * progress;
        element.scrollLeft = newPosition;
    
        if (progress < 1) {
          requestAnimationFrame(scrollFrame);
        }
      }
    
      requestAnimationFrame(scrollFrame);
    },

    renderIframeIn: function(element, videoId) {
        const iframe = document.createElement('iframe');
        iframe.setAttribute('src', 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&mute=1&enablejsapi=1');
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allowfullscreen', '');
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        element.innerHTML = '';
        element.appendChild(iframe);
    },

    openConsentPreferences: function() {
        if (typeof window?.Pandectes?.fn?.openPreferences === 'function') {
            window.Pandectes.fn.openPreferences();
        }
    },

    getConsentStatus: function(preferences = null) {
        let prefs = preferences;
      
        if (prefs === null) {
          if (window?.Pandectes?.hasInitialized && typeof window.Pandectes.getCurrentConsent === 'function') {
            prefs = window.Pandectes.getCurrentConsent()?.preferences ?? 7;
          } else {
            prefs = 7; // block all optional cookies by default
          }
        }
      
        return {
          functionality: (prefs & 1) === 0,
          performance: (prefs & 2) === 0,
          targeting: (prefs & 4) === 0
        };
    },

    subscribeCustomerMaestra: async function({
      email,
      source,
      brand = "selkirkcom",
      pointOfContact = "Email",
      endpoint = "https://api.selkirk.com/functions/v1/p1/selkirksport/maestra/backendSubscription",
      formType = null, // required, e.g. "notify", "backInStock"
      productShopifyId = null, // required if formType is "backInStock"
      topic = null, // Required if formType is "notify". E.g. "labs", "AllInWithSelkirk"
      fingerprint = null, // optional
      referralLink = null, // optional
      firstName = null, // optional
      lastName = null, // optional
      phone = null // optional
    }) {
      if (!email) {
        return { ok: false, error: "Email is required" };
      }

      if (!formType) {
        return { ok: false, error: "formType is required" };
      }    
    
      function getCookie(name) {
        const match = document.cookie.match(
          new RegExp(
            "(?:^|; )" +
              name.replace(/([.*+?^${}()|[\\]\\\\])/g, "\\$1") +
              "=([^;]*)"
          )
        );
        return match ? decodeURIComponent(match[1]) : null;
      }
    
      // Build URL with deviceUUID and formType
      const deviceUUID = getCookie("maestraDeviceUUID");
      const queryParams = new URLSearchParams();
      if (deviceUUID) {
        queryParams.set("deviceUUID", deviceUUID);
      }
      queryParams.set("formType", formType);
      const url = `${endpoint}?${queryParams.toString()}`;
    
      let payload = null;
      
      // Note: The subscriptions array is only valid in the "notify" form type
      switch (formType) {
        case "backInStock":
          if (!productShopifyId) {
            return { ok: false, error: "productShopifyId is required for backInStock" };
          }
          payload = {
            customer: { email: email },
            addProductToList: {
              product: {
                ids: { shopifyid: String(productShopifyId) }
              }
            }
          };
          break;
    
        case "notify":
          payload = {
            customer: {
              email,
              mobilePhone: phone,
              subscriptions: [
                {
                  brand: brand,
                  pointOfContact: pointOfContact,
                  topic: topic
                }
              ]
            },
            customerAction: {
              customFields: {
                actionSource: source || "Unknown"
              }
            }
          };
          break;

        case "referralSignup":
          payload = {
            customer: {
              email,
              firstName,
              lastName,
              mobilePhone: phone,
              customFields: {
                referralLink,
                fingerprint
              }
            }
          };
          break;

        default:
          return { ok: false, error: `Unsupported formType: ${formType}` };
      }
    
      try {
        const resp = await fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json", "x-region": "us-west-1" },
          body: JSON.stringify(payload)
        });
    
        let data = null;
        try {
          data = await resp.json();
        } catch (jsonError) {
          console.error("Error parsing response JSON:", jsonError);
        }
    
        const result = {
          ok: resp.ok,
          status: data?.status ?? resp.status,
          statusMessage: data?.statusMessage ?? resp.statusText,
          data: data?.data ?? null,
          raw: data
        };
    
        if (!resp.ok) {
          result.error = "Subscription failed, try again later.";
        }
    
        return result;
      } catch (err) {
        return { ok: false, error: "Subscription failed, try again later." };
      }
    },
    

    /**
     * initResponsiveRive: initialize Rive with responsive resize handling.
     * Supports lazy/“in view” loading via IntersectionObserver.
     *
     * Params:
     *  - src: string URL of the .riv asset
     *  - canvasEl: HTMLCanvasElement target
     *  - initialLayout: optional rive.Layout to apply initially
     *  - fillOnResize: boolean, if true switches to Fill layout after load (default: true)
     *  - lazy: optional object to defer load until in view:
     *      { threshold?: number, root?: Element|null, rootMargin?: string }
     *      if provided, waits until intersection before loading.
     *
     * Returns: Promise resolving to the Rive instance (or null if canvasEl missing).
     */
    initResponsiveRive: async function ({
      src,
      canvasEl,
      initialLayout,
      fillOnResize = true,
      lazy = null,
    }) {
      if (!canvasEl) return null;

      // actual instantiation logic
      const createInstance = () =>
        new Promise((resolve) => {
          const riveInstance = new rive.Rive({
            src,
            canvas: canvasEl,
            autoplay: true,
            layout: initialLayout,
            onLoad: () => {
              riveInstance.resizeDrawingSurfaceToCanvas();
              resolve(riveInstance);
            },
          });

          if (fillOnResize) {
            riveInstance.layout = new rive.Layout({ fit: rive.Fit.Fill });
          }

          const resize = () => {
            riveInstance.resizeDrawingSurfaceToCanvas();
          };

          window.addEventListener('resize', resize);
          window
            .matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`)
            .addEventListener('change', resize);
        });

      // If lazy config provided and IntersectionObserver exists, defer until visible
      if (
        lazy &&
        typeof IntersectionObserver !== 'undefined' &&
        canvasEl instanceof Element
      ) {
        return new Promise((resolve) => {
          const observer = new IntersectionObserver(
            (entries, obs) => {
              for (const entry of entries) {
                if (entry.isIntersecting) {
                  obs.unobserve(canvasEl);
                  createInstance().then(resolve);
                  return;
                }
              }
            },
            {
              threshold: lazy.threshold ?? 1,
              root: lazy.root ?? null,
              rootMargin: lazy.rootMargin ?? '0px',
            }
          );
          observer.observe(canvasEl);
        });
      } else {
        // immediate load
        return createInstance();
      }
    },
    initVideoThumbs: function(videoThumbs, innerHTML) {
      if (window?.Pandectes?.hasInitialized) {
        const consentStatus = Utility.getConsentStatus();
        this.hasFunctionalityConsent = consentStatus.functionality;
      }
      videoThumbs.forEach((element) => {
        if (element.dataset.bound === 'true') return;
        element.dataset.bound = 'true';

        element.addEventListener('click', this.handleVideoClick.bind(this));
      });
    
      window.addEventListener('PandectesEvent_OnInitialize', (event) => {
        const consentStatus = Utility.getConsentStatus(event.detail.preferences);
        this.hasFunctionalityConsent = consentStatus.functionality;
      });
    
      // Handle consent change
      window.addEventListener('PandectesEvent_OnConsent', (event) => {
        const consentStatus = Utility.getConsentStatus(event.detail.preferences);
        this.hasFunctionalityConsent = consentStatus.functionality;

        // If the user had clicked a video previously, and now consent is granted
        if (this.hasFunctionalityConsent && this.lastClickedVideo?.element && this.lastClickedVideo?.videoId) {
          const { element, videoId } = this.lastClickedVideo;
          if (innerHTML.includes('<video_id>')) {
            innerHTML = innerHTML.replaceAll('<video_id>', videoId);
          }
          element.innerHTML = innerHTML;
          element.dataset.bound = 'false';
          element.addEventListener('click', this.handleVideoClick.bind(this));
          this.lastClickedVideo = null;
        }
      });
    },
    handleVideoClick: function(event) {
      const element = event.currentTarget;
      const videoId = element.getAttribute('data-video-id');
    
      if (this.hasFunctionalityConsent) {
        this.renderIframeIn(element, videoId);
      } else {
        this.lastClickedVideo = { element, videoId };
        element.innerHTML = `
          <div class="video-consent-message">
            <p>To view this video, please accept functionality cookies.</p>
            <button class="open-consent-btn">Manage Preferences</button>
          </div>
        `;
        const btn = element.querySelector('.open-consent-btn');
        if (btn) btn.addEventListener('click', this.openConsentPreferences);
      }
    },

    /**
     * Prevents a popup trigger from firing unless the user has granted targeting cookie consent.
     *
     * On click:
     *  • If targeting consent is granted, the event is allowed to proceed and PopMechanic opens the popup.
     *  • If not, the click is fully blocked, the button is disabled, and an inline message is shown
     *    prompting the user to manage their cookie preferences.
     *
     * Also listens for consent changes: when targeting cookies are later granted, any messages are
     * removed and all previously disabled buttons are re-enabled.
     *
     * @param {object} options
     * @param {string} options.triggerSelector – CSS selector for the popup button(s) to select.
     * @param {string} options.containerSelector – CSS selector for the element to append the warning message into.
     * @param {string} options.messageText – The warning copy to display before the manage-consent link.
     * @param {string} options.linkText – The text for the “Manage cookie preferences” link.
     * @param {Function} options.manageHandler – Callback function that opens the cookie-preferences banner.
     */
    initMaestraPopupConsent: function({
      triggerSelector,
      containerSelector,
      messageText,
      linkText,
      manageHandler
    }) {
      const triggers = Array.from(document.querySelectorAll(triggerSelector));
      triggers.forEach(el => {
        if (el.dataset.maestraBound) return;
        el.dataset.maestraBound = 'true';

        // Capture phase so this runs before PopMechanic’s handler
        el.addEventListener('click', e => {
          const targetingOk = Utility.getConsentStatus().targeting;
          if (targetingOk) return; // if consent present, allow popup

          // No consent: cancel everything, disable the button, show the message
          e.preventDefault();
          e.stopImmediatePropagation(); // prevents any other click handlers
          el.disabled = true;

          const container = el.closest(containerSelector);
          if (!container) return;
          container.querySelectorAll('.maestra-popup-message').forEach(n => n.remove());

          const msgEl = document.createElement('div');
          msgEl.className = 'maestra-popup-message';
          msgEl.style.marginTop = '1rem';
          msgEl.style.color = '#fff';

          msgEl.append(document.createTextNode(messageText));
          msgEl.append(document.createElement('br'));

          const a = document.createElement('a');
          a.className = 'manage-consent';
          a.textContent = linkText;
          a.href = '#';
          a.style.fontWeight = '700';
          a.style.color = '#fff';
          a.style.textDecoration = 'underline';
          a.addEventListener('click', ev => {
            ev.preventDefault();
            manageHandler();
          });
          msgEl.append(a);

          container.append(msgEl);
        }, { capture: true });

      });

      // Re-enable buttons and clear messages once targeting consent is granted
      window.addEventListener('PandectesEvent_OnConsent', ev => {
        if (Utility.getConsentStatus(ev.detail.preferences).targeting) {
          triggers.forEach(el => el.disabled = false);
          document.querySelectorAll('.maestra-popup-message').forEach(n => n.remove());
        }
      });
      
      window.addEventListener('PandectesEvent_OnConsent', ev => {
        const targetingAllowed = Utility.getConsentStatus(ev.detail.preferences).targeting === false;
        if (targetingAllowed) {
          triggers.forEach(btn => btn.disabled = false);
          document.querySelectorAll('.maestra-popup-message').forEach(n => n.remove());
        }
      });
    },

    hideProgressBarPopup: function () {
      const popup = document.getElementById('progress-bar-popup');
      const reopen = document.getElementById('pb-reopen');
      const OPEN_STATE_KEY = 'pbOpenState';

      if (!popup || !reopen) return;

      // Save the current state before hiding
      let wasOpen = popup.classList.contains('is-open') && popup.getAttribute('aria-hidden') === 'false';
      let wasClosed = !wasOpen && reopen.style.display === 'flex';

      try {
        if (wasOpen) {
          sessionStorage.setItem(OPEN_STATE_KEY, 'open');
        } else if (wasClosed) {
          sessionStorage.setItem(OPEN_STATE_KEY, 'closed');
        }
      } catch (e) { }

      // Hide popup and FAB temporarily
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      reopen.style.display = 'none';
    },
    
    restoreProgressBarPopup: function () {
      const popup = document.getElementById('progress-bar-popup');
      const reopen = document.getElementById('pb-reopen');
      const OPEN_STATE_KEY = 'pbOpenState';

      if (!popup || !reopen) return;

      let state = null;
      try {
        state = sessionStorage.getItem(OPEN_STATE_KEY);
      } catch (e) { }

      if (state === 'open') {
        popup.classList.add('is-open');
        popup.setAttribute('aria-hidden', 'false');
        reopen.style.display = 'none';
      } else if (state === 'closed') {
        popup.classList.remove('is-open');
        popup.setAttribute('aria-hidden', 'true');
        reopen.style.display = 'flex';
        reopen.style.opacity = '1';
      }
    },
};